module.exports = __webpack_public_path__ + "static/media/bct.96c0d161.png";